import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const LocationsLogTableSkeleton = () => {
  return [...Array(10)].map(() => (
    <tr key={uuidv4()} className={style.locationsLogsTableBodyRow}>
      <td>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td className={style.hideColumn}>
        <SkeletonBlock className={style.skeletonText} />
      </td>
      <td>
        <SkeletonBlock className={style.skeletonText} />
      </td>
    </tr>
  ));
};

export default LocationsLogTableSkeleton;
